import { useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";

const HIDDEN_PATHS = ["/login", "/register", "/forgot-password", "/reset-password", "/join", "/admin",];

export default function WhatsAppButton() {
  const location = useLocation();
  const [pos, setPos] = useState({ x: null, y: null });
  const [dragging, setDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const btnRef = useRef(null);
  const hasMoved = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!dragging) return;
      hasMoved.current = true;
      setPos({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    };
    const handleTouchMove = (e) => {
      if (!dragging) return;
      hasMoved.current = true;
      const touch = e.touches[0];
      setPos({
        x: touch.clientX - dragOffset.current.x,
        y: touch.clientY - dragOffset.current.y,
      });
    };
    const handleEnd = () => setDragging(false);

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleEnd);
    window.addEventListener("touchmove", handleTouchMove, { passive: true });
    window.addEventListener("touchend", handleEnd);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleEnd);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleEnd);
    };
  }, [dragging]);

  if (HIDDEN_PATHS.includes(location.pathname)) return null;

  const defaultStyle = {
  position: "fixed",
  bottom: pos.x === null ? "80px" : undefined,
  right: pos.x === null ? "20px" : undefined,
  left: pos.x !== null ? `${pos.x}px` : undefined,
  top: pos.y !== null ? `${pos.y}px` : undefined,
  zIndex: 990,
  background: "#25D366",
  borderRadius: "50%",
  width: "52px",
  height: "52px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 16px rgba(37,211,102,0.4)",
  textDecoration: "none",
  fontSize: "24px",
  cursor: dragging ? "grabbing" : "grab",
  userSelect: "none",
  touchAction: "none",
};
  const handleMouseDown = (e) => {
    hasMoved.current = false;
    const rect = btnRef.current.getBoundingClientRect();
    dragOffset.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
    setDragging(true);
  };

  const handleTouchStart = (e) => {
    hasMoved.current = false;
    const touch = e.touches[0];
    const rect = btnRef.current.getBoundingClientRect();
    dragOffset.current = {
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top,
    };
    setDragging(true);
  };

  const handleClick = (e) => {
    if (hasMoved.current) {
      e.preventDefault();
    }
  };

  return (
    <a
      ref={btnRef}
      href="https://wa.me/2348077460114"
      target="_blank"
      rel="noreferrer"
      style={defaultStyle}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onClick={handleClick}
    >
      💬
    </a>
  );
}